<div class="default-dialog-layout">
    <div class="title">Add Property</div>

    <div class="content">
        <form #saveSelectionForm (ngSubmit)="confirm()">
            <cds-form-group layout="horizontal">
                <div class="tree-container">
                    <label>Sources</label>

                    <cds-tree>
                        <ng-template #recursiveSelectionTree let-nodes>
                            <ng-container *ngFor="let node of nodes">
                                <cds-tree-item
                                    [expanded]="node.show"
                                    [expandable]="hasChildren(node)"
                                    (expandedChange)="toggleNode(node)"
                                >
                                    <ng-container>
                                        <cds-checkbox>
                                            <label>{{ node.id }}</label>
                                            <input
                                                type="checkbox"
                                                [ngModel]="node.selected"
                                                (ngModelChange)="selectSelection(node)"
                                                [name]="'checkbox_' + node.id"
                                            />
                                        </cds-checkbox>
                                    </ng-container>
                                    <ng-template #topLevelLabel>
                                        <label>{{ node.id }}</label>
                                    </ng-template>
                                    <ng-container *ngIf="node.show && hasChildren(node)">
                                        <ng-container
                                            *ngTemplateOutlet="
                                                recursiveSelectionTree;
                                                context: { $implicit: node.nodes }
                                            "
                                        >
                                        </ng-container>
                                    </ng-container>
                                </cds-tree-item>
                            </ng-container>
                        </ng-template>

                        <ng-container
                            *ngTemplateOutlet="
                                recursiveSelectionTree;
                                context: { $implicit: nodes }
                            "
                        >
                        </ng-container>
                    </cds-tree>
                </div>
                <ng-container *ngIf="markerIsSelected(nodes[1])">
                    <cds-input>
                        <label>Radius[µm]</label>
                        <input name="radius" [(ngModel)]="radius" required type="number" />
                    </cds-input>
                    <cds-select>
                        <label>Summary</label>
                        <select name="summary" [(ngModel)]="summary" required>
                            <option value="mean">Mean</option>
                            <option value="median">Median</option>
                            <option value="min">Min</option>
                            <option value="max">Max</option>
                            <option value="p10">p10</option>
                            <option value="p90">p90</option>
                        </select>
                    </cds-select>
                </ng-container>
            </cds-form-group>
            <div class="actions action-buttons form-action-buttons">
                <cds-button size="sm" type="button" action="flat" (click)="cancel()"
                    >Cancel</cds-button
                >
                <cds-button size="sm" [disabled]="!saveSelectionForm.checkValidity()" type="submit">
                    Save
                </cds-button>
            </div>
        </form>
    </div>
</div>
